module.exports = __webpack_public_path__ + "img/right-arrow.94e9f1e2.svg";